<template>
    <div>
        <b-container fluid class="pb-3">
            <b-form inline class="mb-3">
                <b-form-datepicker
                id="dtinicio"
                placeholder="data inicio"
                class="mb-2 ml-sm-2 mr-sm-2 mb-sm-0"
                v-model="datainicial"
                ></b-form-datepicker>

                <b-button @click="pesquisa()" variant="primary">Pesquisar</b-button>
                <b-button class="ml-2" variant="info" @click="mostrabotoes = !mostrabotoes">
                    <span v-if="mostrabotoes">Esconder Analítico</span>
                    <span v-if="!mostrabotoes">Mostrar Analítico</span>
                </b-button>
                <b-button class="ml-2" :to="{ name: 'Home'}" variant="primary">Voltar</b-button>
            </b-form>

            <b-row>
                <b-col md="12" xs="12" v-if="loading" class="mt-2 text-center">
                    Pesquisando ...
                </b-col>
                <b-col md="6" xs="12"  class="mt-2" v-for='(especialidade, index) in retornoPesquisa' :key="index">
                    <b-card no-body v-if="!loading">
                        <b-card-header header-bg-variant="primary" header-text-variant="white">
                            <b>{{especialidade.nome}}</b><br>
                                <span v-for='(item, key) in especialidade' :key="key">
                                    <span class="pr-3" v-if="key != 'nome' && key != 'grupos'">
                                        <b style="text-transform:capitalize">{{key}}</b>: {{item}}
                                    </span>
                                </span>
                        </b-card-header>
                        <b-list-group v-if="mostrabotoes">
                            <b-list-group-item v-for='(grupo, key2) in especialidade.grupos' :key="key2">
                                <b>{{grupo.nome}}</b><br>
                                <span v-for='(valor, campo) in grupo' :key="campo">
                                    <span class="pr-3" v-if="campo != 'nome'" style="text-transform:capitalize">
                                        {{campo}} : {{valor}}
                                    </span>
                                </span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>

<script>
import Painel from '../services/PainelService'
import moment from 'moment'

export default {
  name: 'painel',
  data () {
    return {
      retornoPesquisa: [],
      mostrabotoes: false,
      loading: false,
      datainicial: moment().format()
    }
  },
  created () {
    this.pesquisa()
  },
  methods: {
    pesquisa () {
      let pesquisa = {}
      this.loading = true
      const obj = JSON.parse(localStorage.usuarioMC)

      if (obj.empresa !== undefined) {
        pesquisa.empresa = JSON.stringify(obj.empresa)
      }
      pesquisa.usuario = obj.usuario
      pesquisa.datainicial = this.datainicial
      Painel.index(pesquisa).then((result) => {
        this.retornoPesquisa = result[0]
        this.loading = false
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Painel.vue